import React, { useEffect } from 'react';
import { Info, WifiOff } from '../../Buttons/IconButton/Icons';
import Button from '../../Buttons/Button/Button';

interface Props {
  showIcon?: boolean;
  message?: any;
  buttons?: any;
  hideToaster?: Function;
  // children?;
}

const styleVars = getComputedStyle(document.querySelector(':root'));

export function NetworkStatus(props: { isConnected: boolean }) {
  return (
    <div className="sf-chatbot-offline">
      {!props.isConnected ? (
        <div>
          <WifiOff />
          You are offline
        </div>
      ) : (
        <div>Back online</div>
      )}
    </div>
  );
}

export function ToasterMessage(props: Props) {
  useEffect(() => {
    setTimeout(() => {
      var el = document.querySelector(
        '.toaster-buttons-container button:first-child'
      );
      el && (el as HTMLElement).focus();
    }, 100);
  }, []);
  return (
    <div className="toaster-main-body">
      <div className="toaster-message-container" aria-live="polite">
        {props.showIcon ? (
          <div className="toaster-message-icon">
            <Info fill={styleVars.getPropertyValue('--srvMsgBackground')} />
          </div>
        ) : null}
        <div className="toaster-message">
          {props.message ? props.message : null}
        </div>
      </div>
      {props.buttons ? (
        <div className="toaster-buttons-container">
          {props.buttons.map((eachButton, key) => (
            <Button
              fullWidth={true}
              key={key}
              {...eachButton}
              variant={'text'}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
